export { default as SilentCallback } from './SilentCallback.component';
